import { BaseVo } from "./baseVo";
import language from "@/language";
import pcmobile from "@/pcmobile";
import router from '@/router'
import { infoVo as exhibitionInfoVo } from "./exhbitionVo";

export class artworkSimpleVo extends BaseVo{
  get id(){
    return this.$data.id;
  }

  get cover(){
    return this.$data.cover;
  }
  get year(){
    return this.$data.year ? language.text(this.$data.year.cn,this.$data.year.en) : language.text("创作年份不详","Undated");
  }

  get name(){
    return language.text(this.$data.name.cn,this.$data.name.en);
  }

}

export class artworkInfoVo extends artworkSimpleVo{
  get coverAlt(){
    return language.text(this.$data.coverAlt.cn,this.$data.coverAlt.en);
  }
  get artist(){
    let cn = [];
    let en = [];
    if(this.$data.artist){
      for(let i in this.$data.artist){
        cn.push(this.$data.artist[i].cn)
        en.push(this.$data.artist[i].en)
      }
    }

    return language.text(cn.join("、"),en.join(", "));
  }

  get exhibitions(){
    let list = [];
    if(this.$data.exhibitions){
      for(let i in this.$data.exhibitions){
        let info = new exhibitionInfoVo()
        info.convert(this.$data.exhibitions[i]);
        list.push(info);
      }
    }
    return list;
  }

  get size(){
    return language.text((this.$data.size.cn ? this.$data.size.cn : "尺寸可变"), (this.$data.size.en ? this.$data.size.en : "尺寸可变"));
  }

  get thanks(){
    return language.text(this.$data.thanks.cn,this.$data.thanks.en);
  }

  get context(){
    return language.text(this.$data.context.cn,this.$data.context.en);
  }

  get material(){
    return language.text(this.$data.material.cn,this.$data.material.en);
  }

}



export class artistSimpleVo extends BaseVo{
  get id(){
    return this.$data.id;
  }

  get cover(){
    return this.$data.cover;
  }

  get name(){
    return language.text(this.$data.name.cn,this.$data.name.en);
  }

  get country(){
    return language.text(this.$data.country.cn,this.$data.country.en);
  }

  get otherName(){
    return language.text(this.$data.name.en,this.$data.name.cn);
  }
  goDetail(){
    router.push("/artist/detail?id="+this.id);
  }
}



export class artistInfoVo extends artistSimpleVo{
  get birthyear(){
    return this.$data.birthyear;
  }

  get banner(){
    return pcmobile.get(this.$data.banner,this.$data.bannerM);
  }

  get context(){
    return language.text(this.$data.context.cn,this.$data.context.en);
  }

  get coverSummary(){
    return language.text(this.$data.coverSummary.cn,this.$data.coverSummary.en);
  }
}



// WEBPACK FOOTER //
// ./src/vo/archivesVo.js